import { Tooltip, IconButton, Box, Paper, Typography, Divider, TextField, Button, Popover } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import ReactDOM from 'react-dom';
import ReactTooltip from 'react-tooltip';
import { toCurrency, toFormatedNumber } from '../utils/helpers';
import { Info } from '@mui/icons-material';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import OverpriceResultsTable from './OverpriceResultsTable';
import OverpriceResultsTablePrint from './OverpriceResultsTablePrint';
import { NumericFormat } from 'react-number-format';

type Props = {
	min: number;
	q1: number;
	q2: number;
	q3: number;
	max: number;
	threshold: number;
	count_normal: number;
	count_high: number;
	count_alert: number;
	count_anomaly: number;
	count_total: number;
	avg: number;
	count_avg_below: number;
	count_avg_above: number;
	count_median_below: number;
	count_median_above: number;
	print: boolean;
}

function OverpriceVariation({ min, q1, q2, q3, avg, max, threshold, count_normal, count_high, count_alert, count_anomaly, count_total, count_avg_below, count_avg_above, count_median_above, count_median_below, print }: Props) {
	const { overpriceChartFilter, setOverpriceChartFilter } = useContext(GlobalStateContext);
	const { overpriceChartFilterAux, setOverpriceChartFilterAux } = useContext(GlobalStateContext);
	const { description, filters, setFilters, searchType: search_type, countFilters } = useContext(GlobalStateContext);
	const [minPrice, setMinPrice] = React.useState<any>(filters.min_homolog_price || "");
	const [maxPrice, setMaxPrice] = React.useState<any>(filters.max_homolog_price || "");
	const [normalAnchorEl, setNormalAnchorEl] = React.useState<HTMLElement | null>(null);
	const [highAnchorEl, setHighAnchorEl] = React.useState<HTMLElement | null>(null);
	const [alertAnchorEl, setAlertAnchorEl] = React.useState<HTMLElement | null>(null);
	const [anomalyAnchorEl, setAnomalyAnchorEl] = React.useState<HTMLElement | null>(null);

	const [belowAvgAnchorEl, setBelowyAnchorEl] = React.useState<HTMLElement | null>(null);
	const [aboveAvgAnchorEl, setAboveyAnchorEl] = React.useState<HTMLElement | null>(null);
	const [belowMedianAnchorEl, setBelowMedianAnchorEl] = React.useState<HTMLElement | null>(null);
	const [aboveMedianAnchorEl, setAboveMedianAnchorEl] = React.useState<HTMLElement | null>(null);

	const handleNormalPopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
		setNormalAnchorEl(event.currentTarget);
	};

	const handleNormalPopoverClose = () => {
		setNormalAnchorEl(null);
	};
	const handleHighPopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
		setHighAnchorEl(event.currentTarget);
	};

	const handleHighPopoverClose = () => {
		setHighAnchorEl(null);
	};
	const handleAlertPopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAlertAnchorEl(event.currentTarget);
	};

	const handleAlertPopoverClose = () => {
		setAlertAnchorEl(null);
	};
	const handleAnomalyPopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAnomalyAnchorEl(event.currentTarget);
	};

	const handleAnomalyPopoverClose = () => {
		setAnomalyAnchorEl(null);
	};



	const handleBelowAvgPopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
		setBelowyAnchorEl(event.currentTarget);
	};

	const handleBelowAvgPopoverClose = () => {
		setBelowyAnchorEl(null);
	};

	const handleAboveAvgPopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAboveyAnchorEl(event.currentTarget);
	};


	const handleAboveAvgPopoverClose = () => {
		setAboveyAnchorEl(null);
	};

	const handleBelowMedianPopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
		setBelowMedianAnchorEl(event.currentTarget);
	};

	const handleBelowMedianPopoverClose = () => {
		setBelowMedianAnchorEl(null);
	};

	const handleAboveMedianPopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAboveMedianAnchorEl(event.currentTarget);
	};

	const handleAboveMedianPopoverClose = () => {
		setAboveMedianAnchorEl(null);
	}



	const openNormal = Boolean(normalAnchorEl);
	const openHigh = Boolean(highAnchorEl);
	const openAlert = Boolean(alertAnchorEl);
	const openAnomaly = Boolean(anomalyAnchorEl);
	const openBelowAvg = Boolean(belowAvgAnchorEl);
	const openAboveAvg = Boolean(aboveAvgAnchorEl);
	const openBelowMedian = Boolean(belowMedianAnchorEl);
	const openAboveMedian = Boolean(aboveMedianAnchorEl);


	const handleApply = () => {
		let min = minPrice;
		let max = maxPrice;
		if (min == "") {
			min = undefined;
		} else {
			if (isNaN(min)) {
				min = parseFloat(min.replace(",", "."));
			}
		}
		if (max == "") {
			max = undefined;
		} else {
			if (isNaN(max)) {
				max = parseFloat(max.replace(",", "."));
			}
		}
		setFilters({ ...filters, ...{ min_homolog_price: min, max_homolog_price: max } });
	}

	const hasFarout = () => (count_anomaly > 0);
	const farout = () => (100 * threshold);


	const greenWidth = () => (count_normal / count_total) * 100;
	const yellowWidth = () => (count_high / count_total) * 100;
	const redWidth = () => {
		if (hasFarout()) {
			return (count_alert / count_total) * 100;
		} else {
			return 100 - yellowWidth() - greenWidth();
		}

	}
	const grayWidth = () => 100 - redWidth() - yellowWidth() - greenWidth();

	const avgWidth = () => {
		let avg_width_below = ((count_avg_below / count_total) * 100).toFixed(2);
		let avg_width_above = ((count_avg_above / count_total) * 100).toFixed(2);
		return { avg_width_below, avg_width_above }
	}

	const medianWidth = () => {
		let median_width_below = ((count_median_below / count_total) * 100).toFixed(2);
		let median_width_above = ((count_median_above / count_total) * 100).toFixed(2);
		return { median_width_below, median_width_above }
	}

	const tooltipContainer = document.getElementById("tooltip-container");

	const price_range_normal = {
		begin: null,
		end: q3,
		label: "normal"
	}

	const price_range_high = {
		begin: q3 + 0.01,
		end: threshold,
		label: "high"
	}

	const price_range_below_avg = {
		begin: null,
		end: avg,
		label: "below_avg"
	}

	const price_range_above_avg = {
		begin: avg + 0.01,
		end: null,
		label: "above_avg"
	}

	const price_range_below_median = {
		begin: null,
		end: q2,
		label: "below_median"
	}

	const price_range_above_median = {
		begin: q2 + 0.01,
		end: null,
		label: "above_median"
	}

	const price_range_alert = () => {
		if (hasFarout()) {
			return {
				begin: threshold + 0.01,
				end: farout(),
				label: "alert"
			}
		} else {
			return {
				begin: threshold + 0.01,
				end: null,
				label: "alert"
			}
		}

	}

	const price_range_anomaly = {
		begin: farout() + 0.01,
		end: null,
		label: "anomaly"
	}

	const existInFilter = (label: string) => {
		let flag_exist = false
		for (const e of overpriceChartFilter) {
			if (e.label == label) {
				flag_exist = true
			}
		}
		return flag_exist
	}

	const createFilter = (label: string, filter_element: any) => {
		const filter = []
		let flag_exist = false
		for (const e of overpriceChartFilter) {
			if (e.label != label) {
				filter.push(e)
			} else {
				flag_exist = true
			}
		}
		if (!flag_exist) {
			filter.push(filter_element)
		}

		for (let i = 0; i < filter.length; i++) {
			if (filter[i].label == "below_avg" || filter[i].label == "above_avg" || filter[i].label == "below_median" || filter[i].label == "above_median") {
				filter.splice(i, 1)
			}
		}
		return filter
	}

	const createAgvMedianFilter = (label: string, filter_element: any) => {
		if (existInFilter(label)) {
			const filter = [price_range_normal, price_range_high, price_range_alert()]
			return filter
		} else {
			const filter = []
			if (label == "below_avg" || label == "above_avg" || label == "below_median" || label == "above_median") {
				filter.push(filter_element)
			}
			return filter
		}

	}

	const handleNomal = () => {
		setOverpriceChartFilter(createFilter("normal", price_range_normal));
	}

	const handleHigh = () => {
		setOverpriceChartFilter(createFilter("high", price_range_high));
	}

	const handleAlert = () => {
		setOverpriceChartFilter(createFilter("alert", price_range_alert()));
	}
	const handleAnomaly = () => {
		setOverpriceChartFilter(createFilter("anomaly", price_range_anomaly));
	}

	const handleBelowAvg = () => {
		setOverpriceChartFilter(createAgvMedianFilter("below_avg", price_range_below_avg));
	}

	const handleAboveAvg = () => {

		setOverpriceChartFilter(createAgvMedianFilter("above_avg", price_range_above_avg));
	}

	const handleBelowMedian = () => {
		setOverpriceChartFilter(createAgvMedianFilter("below_median", price_range_below_median));
	}

	const handleAboveMedian = () => {
		setOverpriceChartFilter(createAgvMedianFilter("above_median", price_range_above_median));
	}

	useEffect(() => {
		const filter = [price_range_normal, price_range_high, price_range_alert()]
		setOverpriceChartFilter(filter);
		setOverpriceChartFilterAux(filter);
	}, []);

	return (<div className='w-full px-4 py-3'>
		<Typography variant='h6' textAlign={'center'}>Total: {count_total} itens</Typography>
		<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
			<Divider orientation='vertical' sx={{ bgcolor: 'black', height: 20, width: '0.2%' }} />
			<Divider sx={{ bgcolor: 'black', height: 3, width: '99.6%' }} />
			<Divider orientation='vertical' sx={{ bgcolor: 'black', height: 20, width: '0.2%' }} />
		</Box>
		{tooltipContainer && ReactDOM.createPortal(
			<ReactTooltip />,
			tooltipContainer
		)}

		<div className='mt-4 mb-2 h-12 w-full flex relative'>
			<Box
				aria-owns={openNormal ? 'mouse-over-popover' : undefined}
				aria-haspopup="true"
				onMouseEnter={handleNormalPopoverOpen}
				onMouseLeave={handleNormalPopoverClose}
				className="bg-green-600 h-full"
				sx={[{ width: `${greenWidth()}%` }, { '&:hover': { boxShadow: 6, cursor: 'pointer' } }]}>
			</Box>
			<Popover
				id="mouse-over-popover"
				sx={{
					pointerEvents: 'none',
				}}
				open={openNormal}
				anchorEl={normalAnchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={handleNormalPopoverClose}
				disableRestoreFocus
			>
				<Paper className='flex flex-row px-10 p-3' sx={existInFilter("normal") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }}>
					<div className=''>
						<div className='flex flex-col'>
							<div><b>Normal</b></div>
							<div className=''>
								<div>até {toCurrency(q3)}</div>
								<div>{count_normal} itens ({toFormatedNumber(greenWidth())}%)</div>
							</div>
						</div>
					</div>
				</Paper>
			</Popover>


			<Box
				aria-owns={openHigh ? 'mouse-over-popover' : undefined}
				aria-haspopup="true"
				onMouseEnter={handleHighPopoverOpen}
				onMouseLeave={handleHighPopoverClose} className="bg-yellow-600 h-full"
				sx={[{ width: `${yellowWidth()}%` }, { '&:hover': { boxShadow: 6, cursor: 'pointer' } }]}>
			</Box>
			<Popover
				id="mouse-over-popover"
				sx={{
					pointerEvents: 'none',
				}}
				open={openHigh}
				anchorEl={highAnchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={handleAlertPopoverClose}
				disableRestoreFocus
			>
				<Paper className='flex flex-row px-10 p-3' sx={existInFilter("high") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }}>
					<div className=''>
						<div className='flex flex-col'>
							<div><b>Alto</b></div>
							<div className=''>
								<div>{toCurrency(q3+0.01 )} até {toCurrency(threshold)}</div>
								<div>{count_high} itens ({toFormatedNumber(yellowWidth())}%)</div>
							</div>
						</div>
					</div>
				</Paper>
			</Popover>


			<Box
				aria-owns={openAlert ? 'mouse-over-popover' : undefined}
				aria-haspopup="true"
				onMouseEnter={handleAlertPopoverOpen}
				onMouseLeave={handleAlertPopoverClose}
				className="bg-red-600 h-full" sx={[{ width: `${redWidth()}%` }, { '&:hover': { boxShadow: 6, cursor: 'pointer' } }]}>
			</Box>
			<Popover
				id="mouse-over-popover"
				sx={{
					pointerEvents: 'none',
				}}
				open={openAlert}
				anchorEl={alertAnchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={handleAlertPopoverClose}
				disableRestoreFocus
			>
				<Paper className='flex flex-row px-10 p-3' sx={existInFilter("alert") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }}>
					<div className=''>
						<div className='flex flex-col'>
							<div><b>Alerta Sobrepreço</b></div>
							<div className=''>

								{(hasFarout())
									? <div>{toCurrency(threshold + 0.01)} até {toCurrency(farout())}</div>
									: <div>maior que {toCurrency(threshold)}</div>
								}
								<div>{count_alert} itens ({toFormatedNumber(redWidth())}%)</div>
							</div>
						</div>
					</div>
				</Paper>
			</Popover>


			<Box
				aria-owns={openAnomaly ? 'mouse-over-popover' : undefined}
				aria-haspopup="true"
				onMouseEnter={handleAnomalyPopoverOpen}
				onMouseLeave={handleAnomalyPopoverClose}
				className="bg-gray-600 h-full" sx={[hasFarout() ? { width: `${grayWidth()}%` } : { width: '0' }, { '&:hover': { boxShadow: 6, cursor: 'pointer' } }]}>
			</Box>
			<Popover
				id="mouse-over-popover"
				sx={{
					pointerEvents: 'none',
				}}
				open={openAnomaly}
				anchorEl={anomalyAnchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={handleAnomalyPopoverClose}
				disableRestoreFocus
			>
				<Paper className='flex flex-row px-10 p-3' sx={existInFilter("anomaly") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }}>
					<div className=''>
						<div className='flex flex-col'>
							<div><b>Anomalia</b></div>
							<div className=''>
								<div>maior que {toCurrency(farout())}</div>
								<div>{count_anomaly} itens ({toFormatedNumber(100 - redWidth() - greenWidth() - yellowWidth())}%)</div>
							</div>
						</div>
					</div>
				</Paper>
			</Popover>

		</div>

		<div className='mt-2 mb-2 h-2 w-full flex relative'>
			<Box
				aria-owns={openBelowAvg ? 'mouse-over-popover' : undefined}
				aria-haspopup="true"
				onMouseEnter={handleBelowAvgPopoverOpen}
				onMouseLeave={handleBelowAvgPopoverClose}
				className="bg-blue-400 h-full"
				sx={[{ width: `${avgWidth().avg_width_below}%` }, { '&:hover': { boxShadow: 6, cursor: 'pointer' } }]}>
			</Box>
			<Popover
				id="mouse-over-popover"
				sx={{
					pointerEvents: 'none',
				}}
				open={openBelowAvg}
				anchorEl={belowAvgAnchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={handleAnomalyPopoverClose}
				disableRestoreFocus
			>
				<Paper className='flex flex-row px-10 p-3' sx={{ border: 1 }}>
					<div className=''>
						<div className='flex flex-col'>
							<div className='text-center'><b>Média</b> R$ {toFormatedNumber(+avg.toFixed(2))}</div>
							<div className=''>
								<Paper sx={[existInFilter("normal") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }, { p: 1, mb: 1 }]}><div className='flex flex-row'>Abaixo/Igual - {count_avg_below} itens ({toFormatedNumber(+avgWidth().avg_width_below)}%)</div></Paper>
							</div>
						</div>
					</div>
				</Paper>
			</Popover>


			<Box
				aria-owns={openAboveAvg ? 'mouse-over-popover' : undefined}
				aria-haspopup="true"
				onMouseEnter={handleAboveAvgPopoverOpen}
				onMouseLeave={handleAboveAvgPopoverClose}
				className="bg-blue-700 h-full"
				sx={[{ width: `${avgWidth().avg_width_above}%` }, { '&:hover': { boxShadow: 6, cursor: 'pointer' } }]}>
			</Box>
			<Popover
				id="mouse-over-popover"
				sx={{
					pointerEvents: 'none',
				}}
				open={openAboveAvg}
				anchorEl={aboveAvgAnchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={handleAnomalyPopoverClose}
				disableRestoreFocus
			>
				<Paper className='flex flex-row px-10 p-3' sx={{ border: 1 }}>
					<div className=''>
						<div className='flex flex-col'>
							<div className='text-center'><b>Média</b> R$ {toFormatedNumber(+avg.toFixed(2))}</div>
							<div className=''>
								<Paper sx={[existInFilter("normal") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }, { p: 1, mb: 1 }]}><div className='flex flex-row'>Maior - {count_avg_above} itens ({toFormatedNumber(+avgWidth().avg_width_above)}%)</div></Paper>
							</div>
						</div>
					</div>
				</Paper>
			</Popover>
		</div>

		<div className='mt-2 mb-4 h-2 w-full flex relative'>
			<Box
				aria-owns={openAboveMedian ? 'mouse-over-popover' : undefined}
				aria-haspopup="true"
				onMouseEnter={handleBelowMedianPopoverOpen}
				onMouseLeave={handleBelowMedianPopoverClose}
				className="h-full"
				sx={[{ width: `${medianWidth().median_width_below}%`, bgcolor: '#b97a57' }, { '&:hover': { boxShadow: 6, cursor: 'pointer' } }]}>
			</Box>
			<Popover
				id="mouse-over-popover"
				sx={{
					pointerEvents: 'none',
				}}
				open={openBelowMedian}
				anchorEl={belowMedianAnchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={handleBelowMedianPopoverClose}
				disableRestoreFocus
			>
				<Paper className='flex flex-row px-10 p-3' sx={{ border: 1 }}>
					<div className=''>
						<div className=''>
							<div className='text-center'><b>Mediana</b> R$ {toFormatedNumber(+q2.toFixed(2))}</div>
							<div>
								<Paper sx={[existInFilter("normal") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }, { p: 1, mb: 1 }]}><div className='flex flex-row'>Abaixo/Igual - {count_median_below} itens ({toFormatedNumber(+medianWidth().median_width_below)} %)</div></Paper>
							</div>
						</div>
					</div>
				</Paper>
			</Popover>


			<Box
				aria-owns={openAboveMedian ? 'mouse-over-popover' : undefined}
				aria-haspopup="true"
				onMouseEnter={handleAboveMedianPopoverOpen}
				onMouseLeave={handleAboveMedianPopoverClose}
				className="h-full"
				sx={[{ width: `${medianWidth().median_width_above}%`, bgcolor: '#880015' }, { '&:hover': { boxShadow: 6, cursor: 'pointer' } }]}>
			</Box>
			<Popover
				id="mouse-over-popover"
				sx={{
					pointerEvents: 'none',
				}}
				open={openAboveMedian}
				anchorEl={aboveMedianAnchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={handleAnomalyPopoverClose}
				disableRestoreFocus
			>
				<Paper className='flex flex-row px-10 p-3' sx={{ border: 1 }}>
					<div className=''>
						<div className=''>
							<div className='text-center'><b>Mediana</b> R$ {toFormatedNumber(+q2.toFixed(2))}</div>
							<div>
								<Paper sx={[existInFilter("normal") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }, { p: 1, mb: 1 }]}><div className='flex flex-row'>Maior - {count_median_above} itens ({toFormatedNumber(+medianWidth().median_width_above)}%)</div></Paper>
							</div>
						</div>
					</div>
				</Paper>
			</Popover>
		</div>


		<div className='flex flex-row justify-center'>
			<Paper onClick={handleNomal} className='flex flex-row px-10 p-3 mr-5' sx={existInFilter("normal") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }}>
				<div className=''>
					<div className='flex flex-col'>
						<Box className={"h-5 w-16 flex bg-green-600"}></Box>
						<div><b>Normal</b></div>
						<div className=''>
							<div>até {toCurrency(q3)}</div>
							<div>{count_normal} itens ({toFormatedNumber(greenWidth())}%)</div>
						</div>
					</div>
				</div>
			</Paper>

			<Paper onClick={handleHigh} className='flex flex-row px-10 p-3 mr-5' sx={existInFilter("high") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }}>
				<div className=''>
					<div className='flex flex-col'>
						<Box className={"h-5 w-16 flex bg-yellow-600"}></Box>
						<div><b>Alto</b></div>
						<div className=''>
							<div>{toCurrency(q3 + 0.01)} até {toCurrency(threshold)}</div>
							<div>{count_high} itens ({toFormatedNumber(yellowWidth())}%)</div>
						</div>
					</div>
				</div>
			</Paper>

			<Paper onClick={handleAlert} className='flex flex-row px-10 p-3 mr-5' sx={existInFilter("alert") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }}>
				<div className=''>
					<div className='flex flex-col'>
						<Box className={"h-5 w-16 flex bg-red-600"}></Box>
						<div><b>Alerta Sobrepreço</b></div>
						<div className=''>

							{(hasFarout())
								? <div>{toCurrency(threshold + 0.01)} até {toCurrency(farout())}</div>
								: <div>maior que {toCurrency(threshold)}</div>
							}
							<div>{count_alert} itens ({toFormatedNumber(redWidth())}%)</div>
						</div>
					</div>
				</div>
			</Paper>

			{(hasFarout())
				?
				<Paper onClick={handleAnomaly} className='flex flex-row px-10 p-3 mr-5' sx={existInFilter("anomaly") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }}>
					<div className=''>
						<div className='flex flex-col'>
							<Box className={"h-5 w-16 flex bg-gray-600"}></Box>
							<div className='flex flex-row'>
								<b>Anomalia</b>
								<div className='-mt-3'>
									<Tooltip title={<React.Fragment>
										<p>
											Anomalias são itens com preço muito destoante dos demais.
										</p>
										<p className='mt-4'>
											Isso pode acontecer quando estão sendo comparados produtos distintos, ex: "Gasolina" com "Maquina movida à gasolina".
										</p>
										<p className='mt-1'>
											Considere refinar sua busca.
										</p>
										<p className='mt-4'>
											Ou quando o municipio comete um erro de inserção ao enviar os dados.
										</p>
										<p className='mt-1'>
											Considere remover esses itens da sua busca usando o filtro avançado de faixa de Preço Unitário.
										</p>

									</React.Fragment>}>
										<IconButton>
											<Info />
										</IconButton>
									</Tooltip>
								</div>
							</div>

							<div className=''>
								<div>maior que {toCurrency(farout())}</div>
								<div>{count_anomaly} itens ({toFormatedNumber(100 - redWidth() - greenWidth() - yellowWidth())}%)</div>
							</div>


						</div>
					</div>
				</Paper>
				: <div></div>
			}
		</div>

		<div className='flex flex-row justify-center mt-4'>
			<Paper className='flex flex-row px-10 p-3 mr-5'>
				<div className=''>
					<div className='flex flex-col'>
						<div className='text-center'><b>Média</b> R$ {toFormatedNumber(+avg.toFixed(2))}</div>
						<div className=''>
							<Paper onClick={handleBelowAvg} sx={[existInFilter("below_avg") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }, { p: 1, mb: 1, display: 'flex', justifyContent: 'space-between' }]}>
								<div className='flex flex-row'>Abaixo/Igual - {count_avg_below} itens ({toFormatedNumber(+avgWidth().avg_width_below)}%)</div>
								<Box className={"h-5 w-8 flex bg-blue-400 mt-1 ml-2"}></Box>
							</Paper>
							<Paper onClick={handleAboveAvg} sx={[existInFilter("above_avg") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }, { p: 1, mb: 1, display: 'flex', justifyContent: 'space-between' }]}>
								<div className='flex flex-row'>Maior - {count_avg_above} itens ({toFormatedNumber(+avgWidth().avg_width_above)}%)</div>
								<Box className={"h-5 w-8 flex bg-blue-700 mt-1 ml-2"}></Box>
							</Paper>
						</div>
					</div>
				</div>
			</Paper>

			<Paper className='flex flex-row px-10 p-3 mr-5'>
				<div className=''>
					<div className=''>
						<div className='text-center'><b>Mediana</b> R$ {toFormatedNumber(+q2.toFixed(2))}</div>
						<div>
							<Paper onClick={handleBelowMedian} sx={[existInFilter("below_median") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }, { p: 1, mb: 1, display: 'flex', justifyContent: 'space-between' }]}>
								<div className='flex flex-row'>Abaixo/Igual - {count_median_below} itens ({toFormatedNumber(+medianWidth().median_width_below)} %) </div>
								<Box className={"h-5 w-8 flex mt-1 ml-2"} sx={{ bgcolor: '#b97a57' }}></Box>
							</Paper>

							<Paper onClick={handleAboveMedian} sx={[existInFilter("above_median") ? { boxShadow: 6, cursor: 'pointer', border: 1 } : { '&:hover': { boxShadow: 6, cursor: 'pointer' } }, { p: 1, mb: 1, display: 'flex', justifyContent: 'space-between' }]}>
								<div className='flex flex-row'>Maior - {count_median_above} itens ({toFormatedNumber(+medianWidth().median_width_above)}%) </div>
								<Box className={"h-5 w-8 flex  mt-1 ml-2"} sx={{ bgcolor: '#880015' }}></Box>
								
						
								</Paper>
						</div>
					</div>
				</div>
			</Paper>
		</div>
		<Divider sx={{ mt: 3, mb: 1 }} />
		{!print &&
			<>

				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					<div>
						<Typography variant='subtitle2'>Preço Unitário</Typography>
						<div className="flex gap-4 my-2">
							<div className='flex-1'><NumericFormat decimalSeparator="," name='min_homolog_price' value={minPrice} onChange={(ev) => { setMinPrice(ev.target.value) }} customInput={TextField} className='w-full' label="Min." variant="outlined" /></div>
							<div className='flex-1'><NumericFormat decimalSeparator="," name='max_homolog_price' value={maxPrice} onChange={(ev) => { setMaxPrice(ev.target.value) }} customInput={TextField} className='w-full' label="Max." variant="outlined" /></div>
							<div><Button variant='contained' sx={{ mt: 1 }} onClick={handleApply}>Aplicar</Button></div>
						</div>
					</div>

				</Box>

				<Divider sx={{ mt: 3, mb: 1 }} />
			</>
		}


		<div>
			{
				print
					? <OverpriceResultsTablePrint q2={q2} q3={q3} threshold={threshold} />
					: <OverpriceResultsTable q2={q2} q3={q3} threshold={threshold} />
			}
		</div>

	</div>

	);
}

export default OverpriceVariation;
